import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { capitalize } from 'lodash';

// Utils
import { getInitials, mapClientContacts } from 'utils';
import { ClientCentralPropTypes } from 'utils/PropTypesValues';

// Components
import Avatar from 'sharedComponents/Avatar';
import { CheckIcon } from 'sharedComponents/Icons';
import { Typography, ListItem, ListItemText, ListItemAvatar } from '@material-ui/core';

const GroupEmailRecipientsItem = ({
  classes,
  client,
  selectionEnabled,
  selectedClients,
  selectClient,
  emailRecipientsLimit,
}) => {
  const isSelected = selectedClients.find(({ profileId }) => profileId === client.profileId);
  const isDisabled = (selectedClients.length === emailRecipientsLimit && !isSelected) || !client.emails.length;

  const onItemClick = () => {
    if (selectionEnabled && !isDisabled) return selectClient(client);
  };

  return (
    <ListItem
      onClick={onItemClick}
      disableGutters
      key={client.profileId}
      className={cx(classes.link, isDisabled && classes.disabledLink)}
    >
      {/* AVATAR */}
      <ListItemAvatar data-testid="group-clients-select">
        {selectionEnabled && isSelected ? (
          <Avatar className={classes.activeAvatar}>
            <CheckIcon className={classes.icon} />
          </Avatar>
        ) : (
          <Avatar className={cx(classes.avatar, isDisabled && classes.disabledAvatar)}>
            {getInitials(`${client.firstName} ${client.lastName}`)}
          </Avatar>
        )}
      </ListItemAvatar>

      {/* DETAILS */}
      <ListItemText data-testid="group-clients-details">
        {/* FULL NAME */}
        <Typography className={cx(isDisabled && classes.disabledText)} color="textPrimary">
          {`${capitalize(client.firstName)} ${capitalize(client.lastName)}`}
        </Typography>

        {/* EMAIL */}
        <Typography
          className={cx(classes.text, isDisabled && classes.disabledText)}
          variant="body2"
          color="textSecondary"
        >
          {mapClientContacts(null, client.emails || client.email, '•')}
        </Typography>
      </ListItemText>
    </ListItem>
  );
};

GroupEmailRecipientsItem.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  client: ClientCentralPropTypes,
  selectClient: PropTypes.func,
  selectedClients: PropTypes.arrayOf(PropTypes.object),
  selectionEnabled: PropTypes.bool,
};

GroupEmailRecipientsItem.defaultProps = {
  selectClient: () => {},
  selectionEnabled: false,
  selectedClients: [],
  classes: {},
};

export default React.memo(GroupEmailRecipientsItem);
